import React, {useState} from 'react';
import {Form, Grid, Header, Segment, Table} from 'semantic-ui-react';
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import useMaskUtils from "../../../../shared/utils/hooks/useMaskUtils";
import {ToasterConfig} from "../../../../config/ToasterConfig";
import useClientService from "../../../../services/backoffice/hooks/useClientService";
import {CreateClientRequest} from "../../../../models/requests/create-client-request";

const CreateClientPage = () => {
    const [client, setClient] = useState<Partial<CreateClientRequest>>({});
    const navigate = useNavigate();
    const {maskCnpj, unMask} = useMaskUtils();
    const {createClient} = useClientService();

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = event.target;
        setClient((prevClient) => ({
            ...prevClient,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        try {
            await createClient({...client, cnpj: unMask(client.cnpj)})
            // handle success
            navigate('/backoffice/clients/')
            toast.success('Cliente criado com sucesso', ToasterConfig.success);
        } catch (error) {
        }
    };

    return (
        <div>
            <Grid.Column mobile={16} tablet={8} computer={6}>
                <Header as="h3" textAlign="center" color={'green'}>
                    Clientes / Adicionar
                </Header>
                <Segment>
                    <Form onSubmit={handleSubmit}>
                        <Form.Input
                            label="Nome Fantasia"
                            name="nomeFantasia"
                            type="text"
                            placeholder="Nome"
                            value={client.nomeFantasia}
                            onChange={handleInputChange}
                            required
                        />

                        <Form.Input
                            label="Razão Social"
                            name="razaoSocial"
                            type="text"
                            placeholder="Razão Social"
                            value={client.razaoSocial}
                            onChange={handleInputChange}
                            required
                        />

                        <Form.Input
                            label="Cnpj"
                            name="cnpj"
                            type="text"
                            placeholder="00.000.000/0000-00"
                            value={maskCnpj(client.cnpj)}
                            onChange={handleInputChange}
                            required
                            maxLength={18}
                            mask={"00.000.000/0000-00"}
                        />

                        <Table.Row>
                            <Table.HeaderCell>
                                <Form.Button content="Voltar"
                                             icon='arrow left'
                                             onClick={() => navigate('/backoffice/clients/')} grey/>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                <Form.Button content="Adicionar"
                                             type={"submit"}
                                             icon='save'
                                             color={"green"}/>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Form>
                </Segment>
            </Grid.Column>
        </div>
    );
};

export default CreateClientPage;
